import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import BackgroundFx from "./components/BackgroundFx";
import useReferralCapture from "./hooks/useReferralCapture";

import Home from "./pages/Home";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import FAQ from "./pages/FAQ";
import Tutorials from "./pages/Tutorials";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import CheckoutPayment from "./pages/CheckoutPayment";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancelled from "./pages/CheckoutCancelled";
import Track from "./pages/Track";
import Admin from "./pages/Admin";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminInvite from "./pages/AdminInvite";
import Affiliates from "./pages/Affiliates";
import Satisfaction from "./pages/Satisfaction";
import ClientCopytrading from "./pages/ClientCopytrading";
import ClientAnalytics from "./pages/ClientAnalytics";

import "./App.css";

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <ReferralCaptureWrapper>
          <div className="min-h-screen flex flex-col bg-[#05050A] text-white relative">
            <BackgroundFx />
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/features" element={<Features />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/checkout/:planId" element={<Checkout />} />
                <Route path="/checkout/:planId/payment" element={<CheckoutPayment />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancelled" element={<CheckoutCancelled />} />
                <Route path="/track/:orderId" element={<Track />} />
                <Route path="/affiliates" element={<Affiliates />} />
                <Route path="/satisfaction/:ticket_id" element={<Satisfaction />} />
                <Route path="/copytrading" element={<ClientCopytrading />} />
                <Route path="/analytics" element={<ClientAnalytics />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/analytics" element={<AdminAnalytics />} />
                <Route path="/admin/invite/:token" element={<AdminInvite />} />
              </Routes>
            </main>
            <Footer />
            <ChatWidget />
          </div>
        </ReferralCaptureWrapper>
      </BrowserRouter>
    </I18nProvider>
  );
}

function ReferralCaptureWrapper({ children }) {
  useReferralCapture();
  return children;
}
